import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityValue, CuriosityValueProps } from '@procureai/curiosity-ui-mui';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';

export type CuriosityValueValue = Union.Nullable<string>;

interface CuriosityValueCellProps<R extends GridValidRowModel = any> {
  value: CuriosityValueValue;
  row?: R;
  fallback?: string;
  ns: CuriosityValueProps['ns'];
}

export const CuriosityValueCell = <R extends GridValidRowModel = any>({
  value,
  ns,
  fallback,
}: CuriosityValueCellProps<R>) => {
  return value ? <CuriosityValue ns={ns} i18nKey={value} fallback={fallback} /> : <>{NULLISH_CELL_VALUE}</>;
};
